import { render, staticRenderFns } from "./NewBanks.vue?vue&type=template&id=f47aba12&scoped=true"
import script from "./NewBanks.vue?vue&type=script&lang=js"
export * from "./NewBanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47aba12",
  null
  
)

export default component.exports